import { Button } from "@pivus/ui/Button/Button";
import { View } from "@pivus/ui/style/primitives/dripsy";
import { useCallback, useEffect, useState } from "react";
import type { ComponentProps, FunctionComponent } from "react";

import { FieldInput } from "../FieldInput/FieldInput";

type Fields = {
	email: string;
	password: string;
};

// TODO: Standardize this with SignupForm
export const LoginForm: FunctionComponent<
	{
		loading?: boolean;
		onSubmit?: (data: Fields) => void;
		onChange?: (data: Fields) => void;
	} & ComponentProps<typeof View>
> = ({ loading = false, onSubmit, onChange, ...props }) => {
	const [email, setEmail] = useState<string>("");
	const [password, setPassword] = useState<string>("");

	useEffect(() => {
		onChange?.({ email, password });
	}, [email, password]);

	const submitLogin = useCallback(() => {
		onSubmit?.({ email, password });
	}, [email, password]);

	// TODO: wrap this in a form on web

	return (
		<View {...props}>
			<FieldInput
				placeholder="Enter your email"
				value={email}
				onChangeText={setEmail}
				keyboardType="email-address"
				autoComplete="email"
				editable={!loading}
				onSubmitEditing={submitLogin}
			/>
			<FieldInput
				placeholder="Enter your password"
				value={password}
				onChangeText={setPassword}
				autoComplete="password"
				secureTextEntry
				editable={!loading}
				onSubmitEditing={submitLogin}
				sx={{ marginBottom: "$4" }}
			/>

			<Button label="Login" onPress={submitLogin} color="secondary" disabled={loading} />
		</View>
	);
};
